import React from "react";
import PropTypes from 'prop-types';

class CalendarInput extends React.Component {


  changeHandler = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  render() {

    return (
      <div>
        <input type="text"
               className= {this.props.isValid === true ? 'calendar-input' : 'calendar-input calendar-input-error'}
               value={this.props.value}
               onClick={this.props.onClick}
               onChange={this.changeHandler}
        />
        <img src="./assets/icons/calendar.svg" alt="Calendar" className="calendar-icon"
             onClick={this.props.onClick}/>
      </div>
    )
  }
}

CalendarInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default CalendarInput;



// WEBPACK FOOTER //
// ./src/components/CalendarInput/CalendarInput.js